<template>
    <div class="modal fade" id="modalAddCompanyPart" tabindex="-1" role="dialog" aria-labelledby="modalAddCompanyPart" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">

                  <h5 class="modal-title" id="confirmationModalLabel">{{$t('string.msg.order.modal.add.company.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="form-row">

                        <div class="col-md-4" style="background-color:#343B4A">
                            <h1 class="col-form-label" style="color:white"  v-if="order && order.systemUser">
                              {{$t('string.msg.orders.data.order.number')}}:&nbsp;
                              {{$t(order.typeOrder)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </h1>
                        </div>

                        <div class="col-md-4" style="background-color:#343B4A">
                          <h1 class="col-form-label" style="color:white" v-if="order && order.typeOrder">
                            {{toUpperCase($t('string.msg.modal.orders.parts.label.truckdriver'))}}:&nbsp; 
                            {{ ` ${camelize(order.systemUser.firstName)} ${camelize(order.systemUser.lastName)}`}}
                          </h1>
                        </div>

                        <div class="col-md-4" style="background-color:#343B4A">
                          <h1 class="col-form-label" style="color:white" v-if="order && order.dateOrder">
                            {{toUpperCase($t('string.msg.orders.date.title'))}}:&nbsp;
                            {{new Date(order.dateOrder).toLocaleDateString()}} - {{new Date(order.dateOrder).toLocaleTimeString()}}
                          </h1>
                        </div>
                    </div>
                    <br>
                    <form>

                      <div class="form-row">
                          <div class="form-group col-md-6">
                                <label for="inputAddress" class="col-form-label">
                                    {{$t('string.msg.company.label.type')}}
                                </label>
                                <select v-model="filters.typeService" class="form-control">
                                    <option value="" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                    <option value="PART_SUPPLIER">{{$t('string.msg.company.label.type.autoparts')}}</option>
                                    <option value="CERTIFIER">{{$t('string.msg.company.label.type.certifier')}}</option>
                                    <option value="SERVICE_PROVIDER" selected>{{$t('string.msg.company.label.type.serviceprovider')}}</option>
                                    <option value="FLEET_DRIVER" selected>{{$t('string.msg.company.label.type.fleetdriver')}}</option>
                                </select>
                          </div>

                            <div class="form-group col-md-6">
                                <label for="inputAddress" class="col-form-label">
                                    Razão Social, Nome Fantasia ou CNPJ
                                </label>
                                <autocomplete
                                    :search="onChangeName"
                                    :get-result-value="getResultValue"
                                    @submit="submitFilter"
                                    debounceTime="500"                                    
                                ></autocomplete>
                                <!--<input type="text" v-model="filters.name" class="form-control">-->
                            </div>
                        </div>

                        <div class="form-row">
                            <!--<div class="form-group col-md-6">
                                <label class="col-form-label">
                                    {{$t('string.msg.companies.search.label.company.cnpj')}}
                                </label>
                                <input type="text" v-mask="'##.###.###/####-##'" v-model="filters.cnpj" class="form-control">
                            </div>-->

                            <div class="form-group col-md-6">
                                <label class="col-form-label">
                                    {{$t('string.msg.companies.search.label.company.city')}}
                                </label>
                                <input type="text" v-model="filters.city" class="form-control">
                            </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group col-md-4">
                            <div class="justify-content-between">
                              <button @click="filter" class="btn btn-success w-100">{{$t('string.msg.form.btn.search')}}</button>
                            </div>
                          </div>
                        </div>
                      
                        <div class="form-row">
                          <div class="pb-0 pt-3 ">
                            <jw-pagination :items="items" @changePage="onChangePage"></jw-pagination>
                          </div>

                            <div class="table-responsive">
                               <div id="table" style="height:450px;overflow-y:scroll">
                                <table class="table table-centered table-hover mb-0" id="datatable">
                                    <thead>
                                        <tr>
                                            <th class="border-top-0">{{$t('string.msg.company.label.fantasyName')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.company.label.document')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.company.label.type')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.company.label.main.email')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.company.label.primaryPhone')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer" @click="selectItem(item)">
                                            <td>
                                                <span>
                                                    {{toUpperCase(item.socialName)}}
                                                </span>
                                            </td>
                                            <td>
                                                <input type="tel" v-mask="'##.###.###/####-##'" readonly class="form-control reset-input" :value="item.document">
                                            </td>
                                            <td>
                                                <p>
                                                    {{item.typeService.includes("SERVICE_PROVIDER") ? $t('string.msg.company.label.type.serviceprovider') : ''}}
                                                </p>
                                                <p>    
                                                    {{item.typeService.includes("PART_SUPPLIER") ? $t('string.msg.company.label.type.autoparts'): ''}}
                                                </p>
                                                <p>
                                                    {{item.typeService.includes("CERTIFIER") ? $t('string.msg.company.label.type.certifier') : ''}}
                                                </p>
                                                  <p>
                                                    {{item.typeService.includes("FLEET_DRIVER") ? $t('string.msg.company.label.type.fleetdriver') : ''}}
                                                </p>
                                            </td>
                                            <td>
                                                <span>
                                                    {{(item.email)}}
                                                </span>
                                            </td>
                                            <td>
                                                <span>
                                                    {{(item.primaryPhone)}}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                          </div>
                        </div>
                    </div>
                </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{$t('string.msg.term.btn.exit')}}</button>
                </div>
            </div>
        </div>
         <Spinner />
         <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
         <FlashMessage/>
    </div>
</template>

<script>
import Spinner from '../../../../components/layout/Spinner';
import Toast from '../../../../components/layout/Toast';
import Dropdown from 'vue-simple-search-dropdown';
import Controller from './CrtModalAddCompany';
import JwPagination from 'jw-vue-pagination';
import Vue from 'vue'
Vue.component('jw-pagination', JwPagination);

    export default {
        components: {
        },
        props: ["curOrder"],
        watch:{
            'curOrder'(order){
                if(order)                   
                    this.order = order;
            },
        },
        data() {
            return {
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
                items: [],
                orderSelected: null,
                delivery: 'yes',
                informationOk: 'yes',
                descriptionCertifie: null,
                order: null,
                pageOfItems: [],
                data:{
                  _id: null,
                  company: null
                },
                filters: {
                    typeService: '',
                    name: "",
                    isHideDetailsManufecturerFamily: true,
                    isHideDetailsCertifies: true,
                    isHideDetailsServiceFamilies: true,
                    skip: 0,
                    limit: 999999,
                    city: '',
                    cnpj: ''
                },
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false /* doesn't work with directive */
                },
                data: {
                }
            }
        },
        methods: Controller.methods,
        created() {
        },
        mounted(){
            
            Controller.init(this);
        }
     
}
</script>

